// Voz del Búho-JASQ®.
// Voz principal: ElevenLabs (voces latinas por edad) vía backend /api/tts, con
// caché en disco. Respaldo: OpenAI TTS y, en último caso, la voz del navegador.
import { api } from "./api";

const STORAGE_KEY = "jasq_owl_voice";

let enabled = (() => {
  try { return localStorage.getItem(STORAGE_KEY) === "1"; } catch { return false; }
})();

// Grupo de edad activo → determina la voz ElevenLabs en el backend.
let currentGroup = "adult";
export function setOwlAgeGroup(age, role) {
  const n = parseInt(age, 10);
  if (role && role !== "estudiante") { currentGroup = "adult"; return currentGroup; }
  if (n > 0 && n <= 10) currentGroup = "kids";
  else if (n > 10 && n <= 15) currentGroup = "teen";
  else if (n > 15 && n <= 25) currentGroup = "young";
  else currentGroup = "adult";
  return currentGroup;
}

// --- Reproducción de audio (TTS backend) ---
let currentAudio = null;
let currentUrl = null;
let playSeq = 0;

// --- Respaldo: voz del navegador ---
let esVoice = null;
function pickVoice() {
  if (!("speechSynthesis" in window)) return;
  const voices = window.speechSynthesis.getVoices() || [];
  if (!voices.length) return;
  esVoice =
    voices.find((v) => /^es/i.test(v.lang) && /(google|mónica|monica|paulina|helena|laura|sabina|female|mujer)/i.test(v.name)) ||
    voices.find((v) => /^es/i.test(v.lang)) ||
    null;
}
if (typeof window !== "undefined" && "speechSynthesis" in window) {
  pickVoice();
  window.speechSynthesis.onvoiceschanged = pickVoice;
}

export const owlVoiceSupported = () =>
  typeof window !== "undefined" && (typeof Audio !== "undefined" || "speechSynthesis" in window);

export const isOwlVoiceOn = () => enabled;

export function setOwlVoice(on) {
  enabled = !!on;
  try { localStorage.setItem(STORAGE_KEY, enabled ? "1" : "0"); } catch (_) {}
  if (!enabled) stopOwl();
  return enabled;
}

export function defaultOwlVoiceForStudents() {
  try {
    if (localStorage.getItem(STORAGE_KEY) === null) enabled = true;
  } catch (_) { enabled = true; }
  return enabled;
}

function speakBrowser(text) {
  if (!("speechSynthesis" in window)) return;
  try {
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.lang = "es-ES";
    u.rate = 0.96;
    u.pitch = 1.12;
    if (esVoice) u.voice = esVoice;
    window.speechSynthesis.speak(u);
  } catch (_) { /* noop */ }
}

export function speakOwl(text, { force = false, speed = 1.0 } = {}) {
  if (typeof window === "undefined") return;
  if (!enabled && !force) return;
  const clean = String(text || "").trim();
  if (!clean) return;

  stopOwl();
  const seq = ++playSeq;

  // 1) Intentar voz ElevenLabs (latina, por edad) desde el backend.
  api
    .post("/tts", { text: clean, group: currentGroup, speed }, { responseType: "blob", timeout: 25000 })
    .then((res) => {
      if (seq !== playSeq) return; // llegó una petición más nueva
      try {
        const url = URL.createObjectURL(res.data);
        const audio = new Audio(url);
        currentAudio = audio;
        currentUrl = url;
        audio.play().catch(() => speakBrowser(clean));
      } catch (_) {
        speakBrowser(clean);
      }
    })
    .catch(() => {
      if (seq !== playSeq) return;
      speakBrowser(clean); // respaldo si el TTS falla
    });
}

export function stopOwl() {
  playSeq++; // invalida cualquier petición en vuelo
  if (currentAudio) {
    try { currentAudio.pause(); currentAudio.src = ""; } catch (_) {}
    currentAudio = null;
  }
  if (currentUrl) {
    try { URL.revokeObjectURL(currentUrl); } catch (_) {}
    currentUrl = null;
  }
  if ("speechSynthesis" in window) {
    try { window.speechSynthesis.cancel(); } catch (_) {}
  }
}
